import { Tooltip } from "@mui/material";
import * as React from "react";
import video_mv_mp4 from "../video/mv.mp4";

/**
 * 輸出判定、残留農薬、EU食品添加物のメニューを表示
 * @param {*} props 
 * @returns 
 */
function MenuMenu(props) {


  return (
    <>
      <div class="mvVideo" style={{background: "none"}}>
        <video src={video_mv_mp4} autoPlay loop muted playsInline ></video>
      </div>
      <div class="mainCatch">
        <h1>日本の農林水産物・食品を、海外へ。</h1>
        <p>本サイトは、日本産農林⽔産物‧食品を輸出する際に把握しておくべき、<br class="forSP" />
          各国・地域への輸出要件・規制情報を提供するサービスです。<br />
          なお、本サイトで取り扱う国・地域、品目については、<br class="forSP" />
          「輸出要件・規制一覧」をご確認ください。</p>
      </div>
      <div class="mainLinkMenu">
        <div class="mainLinkItem">
          <a href="./" class={props.sel == 1 ? "current" : ""} style={{ height: "100%" }}>
            <span class="icon ship"></span>
            {/* <p>輸出判定<br class="forSP" />チェック</p> */}
            <p>簡易輸出<br class="forSP" />判定</p>
          </a>
        </div>
        <div class="mainLinkItem">
          <a href="./D0121RacTop" class={props.sel == 2 ? "current" : ""} style={{ height: "100%" }}>
            {/* <Tooltip title="諸外国における残留農薬基準値に関する情報：農林水産省 (maff.go.jp)に係る検索機能" arrow> */}
            <div>
              <span class="icon yasai"></span>
              {/* <p>残留農薬<br class="forSP" />チェック</p> */}
              <p
                // style={{
                //   fontSize: "10px"
                //   , fontWeight: "100"
                //   , marginTop: "11px"
                // }}
              >
                残留農薬<br class="forSP" />基準値検索
              </p>
            </div>
            {/* </Tooltip> */}
          </a>
        </div>
        <div class="mainLinkItem">
          <a href="./D0131FoodAdditive" class={props.sel == 3 ? "current" : ""} style={{ height: "100%" }}>
            <span class="icon tenkabutsu"></span>
            <p>EU食品添加物<br class="forSP" />データベース検索</p>
          </a>
        </div>
      </div>
    </>
  )
}

export default MenuMenu;
